/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//Standard libraries
import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";

//custom libraries
import { CustomTable as Table } from ".";
import { ConfirmationDialog, TextLink } from "../components";
import Pagination from "../components/pagination";
import { LIMIT } from "../constants/common";
import { TABLE_COLUMNS, TABLE_COLUMNS_V2 } from "../constants/customer";
import { useCustomerSearchForm } from "../hooks";
import * as ROUTES from "./../constants/routes";

export default function CustomerSearchResults() {
  const {
    searchResult,
    clickNext,
    clickPrevious,
    getActions,
    sortAction,
    sortOrder,
    orderBy,
    dialogOption,
    t,
    clickCustomerDetails,
  } = useCustomerSearchForm();

  const isV9 = process.env.COMMERCE_VERSION === "9";

  return (
    <>
      {searchResult.count || searchResult.recordSetTotal ? (
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <Typography variant="h2">
              {t("Customer.SearchResultTitle")}
            </Typography>
          </Grid>
          <Grid item>
            <Table
              data={isV9 ? searchResult.items : searchResult.userDataBeans}
              columns={isV9 ? TABLE_COLUMNS : TABLE_COLUMNS_V2}
              getActions={getActions}
              sortAction={sortAction}
              sortOrder={sortOrder}
              orderBy={orderBy}
              handleViewDetails={clickCustomerDetails}
            />
          </Grid>
          <Grid item>
            {searchResult.items && searchResult.items.length > 0 && (
              <Pagination
                getPrev={clickPrevious}
                getNext={clickNext}
                offset={searchResult.offset}
                limit={LIMIT}
                count={searchResult.count}
              />
            )}
          </Grid>
          <ConfirmationDialog
            heading={dialogOption.message}
            confirmLabel={dialogOption.confirmLabel}
            cancelLabel={"Table.Actions.Cancel"}
            onConfirm={dialogOption.onConfirm}
            onCancel={dialogOption.onCancel}
          />
        </Grid>
      ) : searchResult.count === 0 ? (
        <Grid
          item
          container
          justify="center"
          direction="column"
          alignItems="center"
          className="min-height"
          spacing={1}>
          <Grid item>
            <Typography className="customer-search">
              {t("Common.SearchNoResult")}
            </Typography>
          </Grid>
          <Grid item>
            <Typography className="customer-create" variant="body1">
              {t("Common.NewCustomerMsg")}&nbsp;
              <TextLink
                label={t("Common.CreateNewCustomer")}
                component={Link}
                to={ROUTES.CUSTOMER_NEW}
              />
            </Typography>
          </Grid>
        </Grid>
      ) : (
        <Grid
          item
          container
          justify="center"
          direction="column"
          alignItems="center"
          className="min-height"
          spacing={1}>
          <Grid item>
            <Typography variant="h3">
              {t("Customer.UsageDescription1")}
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="body1">
              {t("Customer.UsageDescription2")}
            </Typography>
          </Grid>
        </Grid>
      )}
    </>
  );
}
